/* eslint-disable */
import React, {
    forwardRef,
    ForwardedRef,
    MutableRefObject,
    useEffect,
    useRef,
} from 'react';
import * as THREE from 'three';
import {
    ReactThreeFiber,
    extend,
    useFrame,
    useThree,
} from '@react-three/fiber';
import CameraControlsDefault from 'camera-controls';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            cameraControlsDefault: ReactThreeFiber.Node<
                CameraControlsDefault,
                typeof CameraControlsDefault
            >;
        }
    }
}

CameraControlsDefault.install({ THREE: THREE as any });
extend({ CameraControlsDefault });

export const CameraControls = forwardRef(
    ({ onControlEnd, onControlStart, ...props }: any, ref: any) => {
        const cameraControls = useRef<any>(null);
        const camera = useThree((state) => state.camera);
        const renderer = useThree((state) => state.gl);
        useFrame((_, delta) => cameraControls.current?.update(delta));
        useEffect(() => () => cameraControls.current?.dispose(), []);

        useEffect(function () {
            onControlStart &&
                cameraControls.current.addEventListener(
                    'controlstart',
                    onControlStart
                );
            onControlEnd &&
                cameraControls.current.addEventListener(
                    'controlend',
                    onControlEnd
                );
        }, []);

        return (
            <cameraControlsDefault
                ref={mergeRefs<CameraControlsDefault>(cameraControls, ref)}
                args={[camera, renderer.domElement]}
                {...props}
            />
        );
    }
);

export type CameraControls = CameraControlsDefault;

function mergeRefs<T>(...refs: (MutableRefObject<T> | ForwardedRef<T>)[]) {
    return (instance: T): void => {
        for (const ref of refs) {
            if (typeof ref === 'function') {
                ref(instance);
            } else if (ref) {
                ref.current = instance;
            }
        }
    };
}
